export default "__VITE_ASSET__Cvr4YLUC__"